export { default } from './report-rm-statement';
